import React from "react";
import Home from "./components/Home";
import Navigation from "./components/Navigation";

function App() {
  return (
    <Navigation>
      <Home />
    </Navigation>
  );
}

export default App;
